export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7226.1224f2ae.jpg";